import React from 'react';

import Status from '../Status';

function RequestPay({ children, onInquiry, isInquiring, isLoading, onOpenCancelModal }) {
  return (
    <div className="instapay_request">
      <div className="instapay_request_header">
        {children}
        {isInquiring && <Status />}
      </div>
      <div className="instapay_request_footer">
        <button
          onClick={onInquiry}
          className="instapay_btn instapay_btn_secondary"
          type="button"
          disabled={isLoading || isInquiring}
        >
          Check payment status
        </button>
        <button
          onClick={onOpenCancelModal}
          className="instapay_btn instapay_btn_light"
          type="button"
          disabled={isLoading}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default RequestPay;
